import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/foneorders.com/app/src/app/(landing)/LandingShell.tsx");
